<div class="tw-w-full tw-py-4 tw-bg-white tw-my-3">
  <div class="tw-flex tw-justify-between tw-items-center tw-font-lexend tw-mt-2 tw-px-4">
    <h3 class="tw-text-gray-900 tw-font-medium tw-text-400 sm:tw-text-500" i18n="@@whatsInsideYourKit"> What's inside your kit </h3>
    <h3 class="tw-flex tw-items-center tw-text-teal-600 tw-text-200 sm:tw-text-300" (click)="goToInstructions()">
      <span i18n="@@readMore" class="tw-tracking-[0.01px]">Read More</span>
      <cs-icon class="tw-h-7 tw-w-5 tw-text-teal-600" [iconName]="'chevron_right'"></cs-icon>
    </h3>
  </div>
  <swiper [config]="swiperConfig">
    @for (slide of slides(); track slide.objectId; let i = $index) {
      <div *swiperSlide class="tw-py-4" [class]="i === slides().length - 1 ? 'tw-pl-2 tw-pr-4' : i === 0 ? 'tw-pl-4' : 'tw-pl-2'" (click)="goToProductDetails(slide.product)">
        <div class="tw-w-full tw-bg-gray-100 tw-flex tw-justify-center tw-items-center tw-rounded-3 tw-overflow-hidden tw-h-[316px] sm:tw-h-[360px] tw-relative">
          <div class="tw-absolute tw-top-2 tw-right-3 tw-text-100 tw-font-lexend">{{ slide.quantityLabel }}</div>
          <img [src]="slide.imageLink" data-testid="kit-product-image" [alt]="slide.title" class="tw-w-full tw-h-full" [class]="slide.isTagged ? 'tw-object-cover' : 'tw-object-contain tw-mb-8'" />
          <div class="tw-absolute tw-bottom-4 tw-left-4">
            <div class="tw-px-1.5 tw-bg-white tw-rounded-1 tw-text-100 tw-mb-2 tw-w-fit tw-tracking-wide tw-py-[1px]">PRODUCT {{ i + 1 }}</div>
            @if (slide.isTagged) {
              <div class="tw-w-2/3">
                <div class="tw-text-300 sm:tw-text-400 tw-font-lexend tw-font-normal tw-leading-4" [innerHTML]="slide.title"></div>
              </div>
            } @else {
              <div class="tw-flex tw-flex-col tw-gap-0">
                <span class="tw-text-200 tw-font-lexend tw-tracking-[0.25px]">{{ slide.title }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </swiper>
  <div class="tw-mb-2 tw-mt-1 tw-px-4">
    <div class="tw-w-full tw-border tw-border-teal-600 tw-rounded-lg tw-py-1.5 tw-text-center tw-text-teal-600 tw-font-lexend tw-text-200 sm:tw-text-300" (click)="goToInstructions()">
      <span i18n="@@KnowHowToUseYourProducts"> Know how to use products </span>
    </div>
  </div>
</div>
